import { handleTokenInvalidation } from './tokenHandler';

let pending;
let checkedToken;
let checkedAt = 0;

// Handshake errors do not expose the HTTP authentication response to WebSocket clients.
// Probe once before connecting; transport failures leave the saved login intact.
export function verifySession(token) {
  if (!token) return Promise.resolve(false);
  if (checkedToken === token && Date.now() - checkedAt < 1000) return Promise.resolve(true);
  if (pending?.token === token) return pending.promise;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 5000);
  const promise = (async () => {
    try {
      const response = await fetch('https://server.battleverse.cn/user/session.do', {
        method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: '{}', cache: 'no-store', signal: controller.signal
      });
      const data = await response.json().catch(() => null);
      if (response.status === 401 || data?.code === -2) {
        handleTokenInvalidation('登录已失效，请重新登录', token);
        return false;
      }
      if (response.ok && data?.code === 0) { checkedToken = token; checkedAt = Date.now(); }
      return true;
    } catch { return true; }
    finally { clearTimeout(timer); if (pending?.token === token) pending = null; }
  })();
  pending = { token, promise };
  return promise;
}
